<template>
  <v-list-item>
		<v-list-item-avatar>
			<v-img v-if="pedido.opción.imagen" :src="pedido.opción.imagen"></v-img>
			<v-icon v-else>mdi-pasta</v-icon>
		</v-list-item-avatar>
		<v-list-item-content>
			<v-list-item-title v-text="pedido.opción.nombre"></v-list-item-title>
			<v-list-item-subtitle v-if="pedido.notas" v-text="pedido.notas"></v-list-item-subtitle>
			<v-list-item-subtitle v-if="pedido.estado === 'NO_ORDENADO'">
				<v-chip x-small color="deep-orange" text-color="white"><v-icon x-small>mdi-alert-circle</v-icon> &nbsp; No ordenado</v-chip>
			</v-list-item-subtitle>
			<v-list-item-subtitle v-if="pedido.estado === 'ORDENANDO'">
				<v-chip x-small color="amber" text-color="white"><v-icon x-small>mdi-upload</v-icon> &nbsp; Ordenando...</v-chip>
			</v-list-item-subtitle>
			<v-list-item-subtitle v-if="pedido.estado === 'ORDENADO'">
				<v-chip x-small color="cyan darken-1" text-color="white"><v-icon x-small>mdi-clipboard-list</v-icon> &nbsp; Ordenado</v-chip>
			</v-list-item-subtitle>
			<v-list-item-subtitle v-if="pedido.estado === 'PREPARANDO'">
				<v-chip x-small color="teal" text-color="white"><v-icon x-small>mdi-chef-hat</v-icon> &nbsp; En preparación</v-chip>
			</v-list-item-subtitle>
			<v-list-item-subtitle v-if="pedido.estado === 'EN_CAMINO'">
				<v-chip x-small color="light-green darken-3" text-color="white"><v-icon x-small>mdi-walk</v-icon> &nbsp; Viene en camino</v-chip>
			</v-list-item-subtitle>
			<v-list-item-subtitle v-if="pedido.estado === 'SERVIDO'">
				<v-chip x-small color="green darken-2" text-color="white"><v-icon x-small>mdi-check-circle</v-icon> &nbsp; Servido</v-chip>
			</v-list-item-subtitle>
			<v-list-item-subtitle v-if="pedido.estado === 'PAGADO'">
				<v-chip x-small color="green darken-4" text-color="white"><v-icon x-small>mdi-check-all</v-icon> &nbsp; Finalizado</v-chip>
			</v-list-item-subtitle>
			<v-list-item-subtitle v-if="pedido.estado === 'CANCELADO'">
				<v-chip x-small color="grey" text-color="white"><v-icon x-small>mdi-cancel</v-icon> &nbsp; Cancelado</v-chip>
			</v-list-item-subtitle>
			<v-list-item-subtitle v-if="pedido.estado === 'ANULADO'">
				<v-chip x-small color="grey" text-color="white"><v-icon x-small>mdi-null</v-icon> &nbsp; Anulado</v-chip>
			</v-list-item-subtitle>
		</v-list-item-content>
	</v-list-item>
</template>

<script>
export default {
  name: 'PedidoItem',
	props: ['pedido']
};
</script>
